import { Calendar, Check, Edit, RotateCcw, Trash2 } from 'lucide-react';
import type { Tarea } from '../../types';

interface Props {
  tarea: Tarea;
  vencida: boolean;
  onAlternarHecha: (tarea: Tarea) => void;
  onEditar: (tarea: Tarea) => void;
  onEliminar: (tarea: Tarea) => void;
}

export function TarjetaTarea({ tarea, vencida, onAlternarHecha, onEditar, onEliminar }: Props) {
  return (
    <div
      className={`rounded-xl shadow-lg p-6 transition-shadow ${
        tarea.hecha ? 'bg-gray-50 opacity-70' : 'bg-white hover:shadow-xl'
      }`}
    >
      <div className="flex justify-between items-start flex-wrap gap-4">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-2 flex-wrap">
            <h3
              className={`text-xl font-bold ${
                tarea.hecha ? 'text-gray-500 line-through' : 'text-gray-800'
              }`}
            >
              {tarea.titulo}
            </h3>
            {vencida && !tarea.hecha && (
              <span className="bg-red-100 text-red-700 text-xs px-2 py-1 rounded-full">
                Vencida
              </span>
            )}
          </div>
          <div className="space-y-2 text-gray-600">
            {tarea.fechaLimite && (
              <p className="flex items-center gap-2">
                <Calendar
                  size={18}
                  className={vencida && !tarea.hecha ? 'text-red-600' : 'text-violet-600'}
                />
                {new Date(tarea.fechaLimite + 'T00:00:00').toLocaleDateString('es-MX', {
                  weekday: 'long',
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                })}
              </p>
            )}
            {tarea.notas && (
              <p className="text-sm text-gray-500 mt-2 whitespace-pre-wrap">{tarea.notas}</p>
            )}
          </div>

          <div className="flex gap-2 mt-4 flex-wrap">
            {tarea.hecha ? (
              <button
                onClick={() => onAlternarHecha(tarea)}
                className="bg-gray-200 hover:bg-gray-300 text-gray-700 px-4 py-2 rounded-lg text-sm flex items-center gap-2 transition-colors"
              >
                <RotateCcw size={16} />
                Reabrir
              </button>
            ) : (
              <button
                onClick={() => onAlternarHecha(tarea)}
                className="bg-violet-500 hover:bg-violet-600 text-white px-4 py-2 rounded-lg text-sm flex items-center gap-2 transition-colors"
              >
                <Check size={16} />
                Marcar hecha
              </button>
            )}
          </div>
        </div>
        <div className="flex gap-2">
          <button
            onClick={() => onEditar(tarea)}
            className="text-blue-600 hover:text-blue-800 p-2 hover:bg-blue-50 rounded-lg transition-colors"
            title="Editar / notas"
          >
            <Edit size={20} />
          </button>
          <button
            onClick={() => onEliminar(tarea)}
            className="text-red-500 hover:text-red-700 p-2 hover:bg-red-50 rounded-lg transition-colors"
            title="Borrar de la lista"
          >
            <Trash2 size={20} />
          </button>
        </div>
      </div>
    </div>
  );
}
